<template >
  <el-dialog
    :title="'日志详情'"
    :close-on-click-modal="false"
    :visible.sync="visible">
    <div id="left" style="text-align: left">


      <el-form :model="dataForm" ref="dataForm"
               label-width="120px">

        <el-row>
          <el-col :span="12">
            <el-form-item :label="'姓名'">
              <div class="min-input-class">{{this.dataForm.userName}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'部门'">
              <div class="min-input-class">{{this.dataForm.bmmc}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="'操作'">
              <div class="min-input-class">{{this.dataForm.operation}}</div>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="'时长（毫秒）'">
              <div class="min-input-class">{{this.dataForm.time}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'状态'">
              <div class="min-input-class">{{this.dataForm.status == '0'?'成功':'失败'}}</div>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row>
          <el-col :span="12">
            <el-form-item :label="'ip地址'">
              <div class="min-input-class">{{this.dataForm.ip}}</div>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="'操作时间'">
              <div class="min-input-class">{{this.dataForm.createTime}}</div>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="'方法'">
              <div class="min-input-class">{{this.dataForm.method}}</div>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="'参数'">
              <div class="min-input-class">{{this.dataForm.params}}</div>
            </el-form-item>
          </el-col>

        </el-row>

        <el-row>
          <el-col :span="24">
            <el-form-item :label="'结果'">
              <div>{{this.dataForm.result}}</div>
            </el-form-item>
          </el-col>

        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="'错误信息'">
              <div class="min-input-class">{{this.dataForm.errorMsg}}</div>
            </el-form-item>
          </el-col>

        </el-row>







      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取消</el-button>
    </span>
  </el-dialog>
</template>

<script>


  export default {
    data () {
      return {
        visible: false,
        dataForm:{
        }
      }
    },
    created () {

    },
    methods: {
      init (id) {
        if(!id) return
        this.visible = true
        this.dataForm = {}
        this.$http({
          url: `/bjba/systemLog/info/${id}`,
          method: 'get'
        }).then(({data}) => {
          console.log('2222222222')
          this.dataForm = data.data
        })
      }

    }
  }
</script>

<style lang="scss" scoped>
  .min-input-class {

    min-height:25px;
    border-bottom:1px dotted  #b0b1b3;
  }
</style>
